import { DEFENDR_HANDLE, DEFENDR_MOCK_PAGE } from "./draft";

export type SearchParamsLike =
  | Record<string, string | string[] | undefined>
  | URLSearchParams
  | undefined;

export const isDefendrMockRequest = (
  handle: string,
  searchParams?: SearchParamsLike,
) => {
  if (handle !== DEFENDR_HANDLE || !searchParams) return false;

  if (searchParams instanceof URLSearchParams) {
    return searchParams.get("mock") === "defendr";
  }

  const mockValue = searchParams.mock;
  return Array.isArray(mockValue)
    ? mockValue.includes("defendr")
    : mockValue === "defendr";
};

const attachPageHandle = (block: any, pageHandle: string): any => {
  if (!block || typeof block !== "object") return block;

  return {
    ...block,
    pageHandle,
    leftBlock: block.leftBlock ? attachPageHandle(block.leftBlock, pageHandle) : block.leftBlock,
    rightBlock: block.rightBlock ? attachPageHandle(block.rightBlock, pageHandle) : block.rightBlock,
  };
};

export const normalizeCategoryPageData = (page: any) => {
  if (!page?.blocksCollection?.items) return page;

  return {
    ...page,
    blocksCollection: {
      ...page.blocksCollection,
      items: page.blocksCollection.items.map((block: any) =>
        attachPageHandle(block, page.handle),
      ),
    },
  };
};

export const splitAwardsBlock = (page: any) => {
  const items = page?.blocksCollection?.items || [];
  const awardsBlock = items.find((block: any) => block.anchor === "awards") || null;
  const contentBlocks = items.filter((block: any) => block.anchor !== "awards");

  return {
    awardsBlock,
    page: {
      ...page,
      blocksCollection: {
        ...page.blocksCollection,
        items: contentBlocks,
      },
    },
  };
};

export const getDefendrPageData = (page: any, useMock: boolean) => {
  const source = useMock ? DEFENDR_MOCK_PAGE : page;
  return splitAwardsBlock(normalizeCategoryPageData(source));
};

export const DEFENDR_CATEGORY_NAV_ITEMS = [
  { label: "Applications", href: "#applications" },
  { label: "Construction", href: "#construction" },
  { label: "Resources", href: "#resources" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Contact Us", href: "#contact-us" },
];
